import { valueOf } from "@/types/common";

export const CONTACT_LIST_TAB = {
  RESOLVED: "RESOLVED",
  UN_RESOLVED: "UN_RESOLVED",
  CONTACT_TYPE: "CONTACT_TYPE",
};

export type TRsoListTab = valueOf<typeof CONTACT_LIST_TAB>;

export const CONTACT_LIST_TAB_LABEL = {
  [CONTACT_LIST_TAB.RESOLVED]: "過去のお問い合わせ一覧",
  [CONTACT_LIST_TAB.UN_RESOLVED]: "新着のお問い合わせ一覧",
  [CONTACT_LIST_TAB.CONTACT_TYPE]: "お問い合わせの種類の管理",
};
